// Hash any string into an integer value
// Then we'll use the int and convert to hex.
function hashCode(str = '') {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}

// Convert an int to hexadecimal with a max length
// of six characters.
function intToARGB(i) {
    let hex =
        ((i >> 24) & 0xff).toString(16) +
        ((i >> 16) & 0xff).toString(16) +
        ((i >> 8) & 0xff).toString(16) +
        (i & 0xff).toString(16);
    // Sometimes the string returned will be too short so we
    // add zeros to pad it out, which later get removed if
    // the length is greater than six.
    hex += '000000';
    return hex.substring(0, 6);
}

export function avatarImage(letters, string, imgSize) {
    let canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const size = imgSize || 60;

    // Set canvas with & height
    canvas.width = size;
    canvas.height = size;

    // Select a font family to support different language characters
    // like Arial
    context.font = Math.round(canvas.width / 2) + 'px Arial';
    context.textAlign = 'center';

    // Setup background and font color
    context.fillStyle = `#${intToARGB(hashCode(string))}`;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#FFF';
    context.fillText(letters, size / 2, size / 1.5);

    // Set image representation in default format (png)
    const dataURI = canvas.toDataURL();

    // Dispose canvas element
    canvas = null;

    return dataURI;
}
